import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { config } from '../../config';

export default function SuppressionAttribution() {
    const [primes, setPrimes] = useState([]);
    const [salaries, setSalaries] = useState([]);
    const [beneficiaires, setBeneficiaires] = useState({});
    const [loading, setLoading] = useState(true);

    // Utilisation de la configuration centralisée
    const API_BASE = `${config.apiBase}/rh`;

    useEffect(() => {
        fetchPrimes();
        fetchSalaries();
    }, []);

    const fetchPrimes = async () => {
        const token = localStorage.getItem('token');
        const res = await fetch(`${API_BASE}/lister_primes.php`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        const data = await res.json();
        if (data.success) {
            setPrimes(data.primes);
            data.primes.forEach(prime => fetchBeneficiaires(prime.id_prime));
        }
        setLoading(false);
    };

    const fetchSalaries = async () => {
        const token = localStorage.getItem('token');
        const res = await fetch(`${API_BASE}/lister_salaries.php`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        const data = await res.json();
        if (data.success) setSalaries(data.salaries);
    };

    const fetchBeneficiaires = async (idPrime) => {
        const token = localStorage.getItem('token');
        const res = await fetch(`${API_BASE}/lister_beneficiaires.php?id_prime=${idPrime}`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        const data = await res.json();
        if (data.success) {
            setBeneficiaires(prev => ({ ...prev, [idPrime]: data.beneficiaires }));
        }
    };

    const supprimerBeneficiaire = async (idPrime, idSalarie) => {
        const token = localStorage.getItem('token');
        const res = await fetch(`${API_BASE}/supprimer_beneficiaire.php`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
            body: JSON.stringify({ id_prime: idPrime, id_salarie: idSalarie })
        });
        const data = await res.json();
        if (data.success) {
            toast.success('Bénéficiaire supprimé');
            setBeneficiaires(prev => ({
                ...prev,
                [idPrime]: prev[idPrime].filter(id => id !== idSalarie)
            }));
        } else {
            toast.error(data.message);
        }
    };

    if (loading) return <div className="p-6 text-center">Chargement...</div>;

    return (
        <div className="p-6">
            <h1 className="text-2xl font-bold text-red-700 mb-6">🗑️ Supprimer une attribution</h1>
            <div className="space-y-8">
                {primes.map(prime => {
                    const benefIds = beneficiaires[prime.id_prime] || [];
                    const benefSalaries = salaries.filter(s => benefIds.includes(s.id_salarie));
                    return (
                        <div key={prime.id_prime} className="bg-white rounded-xl shadow-md p-5 border-l-4 border-red-500">
                            <div className="flex justify-between items-center mb-3">
                                <div>
                                    <h2 className="text-xl font-bold text-gray-800">{prime.nom_prime}</h2>
                                    <p className="text-sm text-gray-500">{parseInt(prime.valeur).toLocaleString()} FCFA</p>
                                </div>
                                <span className="text-sm bg-red-100 text-red-700 px-3 py-1 rounded-full">{benefSalaries.length} bénéficiaire(s)</span>
                            </div>
                            {benefSalaries.length === 0 ? (
                                <p className="text-gray-400 italic">Aucun bénéficiaire pour cette prime.</p>
                            ) : (
                                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mt-3">
                                    {benefSalaries.map(s => (
                                        <div key={s.id_salarie} className="flex justify-between items-center bg-gray-50 p-2 rounded-lg">
                                            <span className="font-medium">{s.nom} {s.prenom}</span>
                                            <button
                                                onClick={() => supprimerBeneficiaire(prime.id_prime, s.id_salarie)}
                                                className="text-red-600 hover:text-red-800 text-sm font-semibold"
                                            >
                                                ❌ Retirer
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}